import { Component, AfterViewInit, Input } from '@angular/core';

import { PdfExportService } from '../../../../services/export-pdf/pdf-export.service';
import { UserService } from '../../../../services/user.service';
import { InfluencerPost } from '../../../../../models/influencer';

@Component({
    selector: 'latest-posts',
    templateUrl: './latest-posts.component.html',
    styleUrls: ['./latest-posts.component.scss']
})
export class LatestPostsComponent implements AfterViewInit {
    static COMPONENT_NAME = 'LatestPosts';

    @Input() latestPosts: InfluencerPost[] = [];
    @Input() forPayingUser = false;
    @Input() printMode: boolean;
    @Input() isFetchingData: boolean;

    constructor(private pdfService: PdfExportService,
                private userService: UserService) {}

    get hasNoData() {
      return this.latestPosts.length === 0
        || (this.forPayingUser && this.userService.isFreeUser() && !this.userService.isAdmin);
    }

    ngAfterViewInit() {
      this.pdfService.incrementNumberReportReady(LatestPostsComponent.COMPONENT_NAME);
    }
  }



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-overview/latest-posts/latest-posts.component.ts